import React, { useEffect, useState } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'
import Typography from '@mui/material/Typography'
import AttachmentIcon from '@mui/icons-material/Attachment'
import styled from 'styled-components'
import * as FileService from '../../../services/attachment.service'
import { sanitizeHtmlMessage } from './sanitize-html-message'

const StyledTypography = styled(Typography)({
  cursor: 'pointer',
  '&:hover': {
    color: '#3f51b5',
    textDecoration: 'underline',
  },
})

const MEDIA_TYPES = ['image', 'audio', 'video']

const ChatAttachmentMedia = ({ item, align }) => {
  const attachment = item.attachment
  const messagetype = item.messagetype
  const isMedia = MEDIA_TYPES.includes(messagetype)

  const [phase, setPhase] = useState(isMedia ? 'resolving' : 'idle')
  const [resolvedUrl, setResolvedUrl] = useState(null)
  const [loadingClick, setLoadingClick] = useState(false)

  useEffect(() => {
    let cancelled = false

    if (isMedia) {
      FileService.getFileByPath(attachment.hirerid, attachment.path, attachment.filerepositorymethod)
        .then(result => {
          if (cancelled) return
          if (result && result.data && result.data.success && result.data.data) {
            setResolvedUrl(result.data.data)
            setPhase('ready')
          } else {
            setPhase('error')
          }
        })
        .catch(() => {
          if (!cancelled) setPhase('error')
        })
    }

    return () => {
      cancelled = true
    }
  }, [attachment.id, attachment.hirerid, attachment.path, attachment.filerepositorymethod, isMedia])

  const openGenericAttachment = async () => {
    if (resolvedUrl) {
      window.open(resolvedUrl, '_blank')
      return
    }
    setLoadingClick(true)
    try {
      const result = await FileService.getFileByPath(attachment.hirerid, attachment.path, attachment.filerepositorymethod)
      if (result && result.data && result.data.success && result.data.data) {
        window.open(result.data.data, '_blank')
      }
    } finally {
      setLoadingClick(false)
    }
  }

  if (isMedia && phase !== 'error') {
    if (phase === 'resolving') {
      return <CircularProgress size={20} />
    }

    if (messagetype === 'image') {
      return (
        <div style={{ textAlign: align }}>
          <img src={resolvedUrl} alt={item.message || ''} style={{ maxWidth: 300, maxHeight: 300, borderRadius: 4 }} onError={() => setPhase('error')} />
          {item.message != null ? <Typography variant="body1" align={align}>{sanitizeHtmlMessage(item.message)}</Typography> : null}
        </div>
      )
    }

    if (messagetype === 'audio') {
      return (
        <div style={{ textAlign: align }}>
          <audio controls src={resolvedUrl} style={{ maxWidth: 300 }} onError={() => setPhase('error')} />
        </div>
      )
    }

    return (
      <div style={{ textAlign: align }}>
        <video controls src={resolvedUrl} style={{ maxWidth: 320, maxHeight: 240 }} onError={() => setPhase('error')} />
      </div>
    )
  }

  return (
    <StyledTypography variant="body1" align={align} onClick={openGenericAttachment}>
      <IconButton size="small" disabled={loadingClick}><AttachmentIcon /></IconButton>
      {item.message != null ? sanitizeHtmlMessage(item.message) : null}
    </StyledTypography>
  )
}

export default ChatAttachmentMedia
